import { createRouter, createWebHistory } from "vue-router";
import ErrorComponent from "@/views/error";

export const constantRoutes = [
  {
    //  '/login' にリダイレクト
    path: "/",
    redirect: "/login", 
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/login"),
    props: route => ({ errorMessage: route.query.errorMessage || '' }),
  },
  {
    path: "/search",
    name: "Search",
    meta: { isActive: 'search' },
    component: () => import("@/views/search/search"),
  },
  {
    path: "/register",
    name: "Register",
    meta: { isActive: 'register' },
    component: () => import("@/views/register/register"),
  },
  {
    path: "/registerCount",
    name: "RegisterCount",
    meta: { isActive: 'registerCount' },
    component: () => import("@/views/registerCount/registerCount"),
  },
  {
    path: "/error",
    name: "Error",
    component: ErrorComponent,
  },
  {
    path: '/:pathMatch(.*)*',
    name:"NotFount",
    component: () => import("@/views/notFound"),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: constantRoutes,
});

export function resetRouter() {
  router.removeRoute("Login");
  router.addRoute(constantRoutes[0]);
}

// ログイン画面遷移時にセッションストレージをクリア
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    sessionStorage.clear(); 
  }
  next();
});

export default router;
